import helper from '@/libs/forms';
import VueFormGenerator from 'vue-form-generator';


const employerNameIsVisible = model => (
  model && !model.selfEmployed
);

const fromDateIsVisible = model => model && typeof model.current === 'boolean';

const toDateIsVisible = model => model && model.current === false;

const toDateValidator = (value, field, model) => (
  new Date(value) < new Date(model.fromDate) ?
    ['This date is less than the one you started working, please change it.'] :
    VueFormGenerator.validators.date(value, field, model)
);

const getFields = (onSubmit) => {
  const maxlength = 255;

  const selfEmployedField = helper.boolRadio('Self-Employed', 'selfEmployed', true, 12);
  selfEmployedField.onChanged = (model, newVal) => {
    /* eslint no-param-reassign: ["error", { "props": false }] */
    if (newVal === true) {
      model.employer = null;
    }
  };

  const nameField = helper.simpleInput(
    'input', 'Name of Employer', '', 'employer', true, 12, null, employerNameIsVisible,
  );
  nameField.maxlength = maxlength;

  const positionField = helper.simpleInput(
    'input', 'Position/Title/Type of Business', '', 'position', true, 7,
  );
  positionField.maxlength = maxlength;

  return [
    selfEmployedField,
    nameField,
    helper.boolRadio('Current Employment', 'current', false, 12),
    helper.phone('Business Phone', 'phone', true, 5),
    helper.date('From', '', 'fromDate', false, 6, null, false, true, null, fromDateIsVisible),
    helper.date('To', '', 'toDate', false, 6, null, false, true, toDateValidator, toDateIsVisible),
    helper.splitAddress('Business Address', 'address', true, ['address', 'unit', 'zipCode']),
    helper.submitBtn('Save', null, onSubmit),
  ];
};


export default {
  schema: onSubmit => ({
    fields: getFields(onSubmit),
  }),
  formOptions: helper.options('employment-', true),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/employment/resources/schema.js